import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Redireciona /app para a tela inicial certa baseada no role:
 * - investor -> /app/feed
 * - entrepreneur -> /app/dashboard
 * - sem role definido ainda -> /app/feed (fallback)
 */
const AppIndexRedirect = () => {
  const { profile } = useAuth();
  const target = profile?.role === 'entrepreneur' ? '/app/dashboard' : '/app/feed';
  return <Navigate to={target} replace />;
};

export default AppIndexRedirect;
